<div class="my-24 flex flex-col gap-24 p-4 md:my-28 md:gap-28">
  <!-- Hero -->
  <app-enterprise-hero-section />
  <!-- Customer Logos -->
  <app-customer-logo-section />
  <!-- Features -->
  <app-enterprise-features-section />
  <!-- Compliance -->
  <app-compliance-section />
  <!-- Scalability -->
  <app-enterprise-scalability-section />
  <!-- Security -->
  <app-enterprise-security-section />
  <!-- Support -->
  <app-enterprise-support-section />
  <!-- Appflow -->
  <app-appflow-section />
  <!-- FAQ -->
  <app-enterprise-faq-section />
  <!-- CTA -->
  <app-enterprise-cta-section />
</div>
